import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71acb8f3&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=71acb8f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acb8f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71acb8f3')) {
      api.createRecord('71acb8f3', component.options)
    } else {
      api.reload('71acb8f3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71acb8f3&scoped=true", function () {
      api.rerender('71acb8f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mcp/index.vue"
export default component.exports